(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-is-at-bottom-window.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-is-at-bottom-window.js');
"use strict";

const {
  useState,
  useEffect
} = React;
const comparativeValue = 0.95;
const useIsAtBottomWindow = () => {
  const isAtBottomCalculation = () => {
    const windowInnerHeight = window.innerHeight;
    const pageYOffset = window.pageYOffset;
    const documentHeight = document.body.offsetHeight;
    return (windowInnerHeight + pageYOffset) / documentHeight >= comparativeValue;
  };
  const [isAtBottom, setIsAtBottom] = useState(() => isAtBottomCalculation());
  useEffect(() => {
    const handleScroll = () => {
      window.requestAnimationFrame(() => {
        setIsAtBottom(isAtBottomCalculation);
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return isAtBottom;
};
setGlobal('svs.components.tipsen.hooks.useIsAtBottomWindow', useIsAtBottomWindow);

 })(window);